import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon, Flex } from 'ui';
import { useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import debounce from 'lodash.debounce';
import { viewConfig } from '../../config';
import { setCurrentPage } from '../../containers/gantt-actions';

const LeftIcon = styled(Icon)`
  margin-left: 20px;
  margin-right: 10px;
`;

const RightIcon = styled(Icon)`
  margin-right: 20px;
  margin-left: 10px;
`;

const StyledFlex = styled(Flex)`
  height: 55px;
`;

const Paging = ({
  addShowingLabel = true,
  intl,
}) => {
  const dispatch = useDispatch();
  const { totalDataCount, currentPage } = useSelector(state => state.gantt);
  const [page, setPage] = useState(currentPage || 0);
  const [dataCount, setDataCount] = useState('0 - 0');

  useEffect(() => {
    setPage(currentPage || 0);
  }, [currentPage]);

  useEffect(() => {
    if (!totalDataCount) {
      setDataCount('0 - 0');
    } else {
      // eslint-disable-next-line
      setDataCount(`${(page - 1) * viewConfig.pageSize + 1} - ${page * viewConfig.pageSize > totalDataCount ? totalDataCount : page * viewConfig.pageSize}`);
    }
  }, [totalDataCount, page]);

  const debouncePaging = useCallback(
    debounce(p => dispatch(setCurrentPage(p)), 300),
    [],
  );

  const handleArrowClick = (isRight) => {
    let newPage = page;
    if (!isRight) {
      if (page > 1) {
        newPage -= 1;
      }
    } else if (page * viewConfig.pageSize < totalDataCount) {
      newPage += 1;
    }
    setPage(newPage);
    debouncePaging(newPage);
  };

  return (
    <StyledFlex data-test-id='gantt-fse-selector' jcc aic>
      <LeftIcon
        type='chevron-left'
        size='lg'
        onClick={() => handleArrowClick(false)}
        disabled={page === 1}
      />
      <p>
        {addShowingLabel &&
          intl.formatMessage({ id: 'planningBoard.SHOWING' })
        }
        {' '}
        <b>
          {intl.formatMessage({ id: 'planningBoard.FSE' })}
          {' '}
          {dataCount}
        </b>
        {' '}
        {
          intl.formatMessage({ id: 'planningBoard.OF' })
        }
        {' '}
        {totalDataCount}
      </p>
      <RightIcon
        type='chevron-right'
        size='lg'
        onClick={() => handleArrowClick(true)}
        disabled={page * viewConfig.pageSize >= totalDataCount}
      />
    </StyledFlex>
  );
};

Paging.propTypes = {
  addShowingLabel: PropTypes.bool,
  intl: PropTypes.object,
};

export default injectIntl(Paging);
